import React, { useState,useEffect } from 'react';
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import { Card,Image,Placeholder } from 'react-bootstrap';
const VisitingCompanies = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousByTypeAll = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/10");
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                                .then(upph => upph.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp,upph]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upph
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscFile = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].miscFileHi = (el.upph.length > 0) ? global.config.uploadPath + el.upph[0].up_fname + el.upph[0].up_ext : '';                            
                        });
                        setMiscellaneous(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('MiscellaneousByTypeAll File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMiscellaneous([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByTypeAll : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByTypeAll : Error', error.message);
            }
        };
        MiscellaneousByTypeAll();   
    },[])
    return (
        <Card className=' mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase'>{appLanguage === 'hi' ? 'विज़िटिंग कंपनियाँ' : 'Visiting Companies'}</Card.Header>
            <Card.Body>
                <ResponsiveMasonry columnsCountBreakPoints={{350: 1, 750: 2, 900: 3, 1200:4}}>
                {isLoading ? (
                    <Masonry gutter="10px">
                    {[...Array(12)].map((_,index)=>(
                        <Placeholder key={index} xs={12} style={{height:"200px"}} className='border p-2' />
                    ))}
                    </Masonry>
                
                ) : (
                    <Masonry gutter="10px">
                        {Miscellaneous.map((sm, index) => (
                        <React.Fragment>
                        {appLanguage === 'hi' ? 
                            (
                                sm.miscFileHi 
                                ? <Image key={index} src={sm.miscFileHi} fluid className='border p-2' /> 
                                : <Image key={index} src={sm.miscFile} fluid className='border p-2' />
                            ) : (
                                <Image key={index} src={sm.miscFile} fluid className='border p-2' />
                            )
                        }
                        </React.Fragment>                             
                        ))}
                    </Masonry>
                )} 
                </ResponsiveMasonry>
            </Card.Body>
        </Card>
    );
}
export default VisitingCompanies;